import React from 'react';
import { AlertTriangle, Building2, FileStack, Mic, Scale, Sparkles } from 'lucide-react';
import { getSourceTrustMeta } from '@/lib/sourceTrust';

const TRUST_ICONS = {
  'Verified Authority': Scale,
  'Verified Government Source': Building2,
  'Matter File': FileStack,
  'Jolly-Derived Matter Memory': Mic,
  'External / Unverified': AlertTriangle,
  Inference: Sparkles,
};

export default function SourceTrustBadge({
  source,
  label,
  compact = false,
  count = null,
  title,
}) {
  const meta = getSourceTrustMeta(source || label);
  const Icon = TRUST_ICONS[meta.label] || AlertTriangle;
  const renderedLabel = compact ? meta.shortLabel : meta.label;

  return (
    <span
      title={title || meta.description}
      style={{
        display: 'inline-flex',
        alignItems: 'center',
        gap: compact ? '4px' : '6px',
        padding: compact ? '4px 8px' : '5px 10px',
        borderRadius: '999px',
        background: meta.background,
        border: meta.border,
        color: meta.color,
        fontSize: compact ? '10px' : '11px',
        fontWeight: 700,
        fontFamily: 'var(--font-ui)',
        lineHeight: 1,
        whiteSpace: 'nowrap',
      }}
    >
      <Icon size={compact ? 10 : 12} />
      <span>{renderedLabel}</span>
      {count != null ? <span style={{ opacity: 0.8 }}>{count}</span> : null}
    </span>
  );
}
